import './PriceBreakdownItem.scss'
import { FunctionComponent } from 'react'
import { UXComponentRenderer } from 'src/componentsV2/CoreUX/UXComponentRenderer/UXComponentRenderer'
import { PriceBreakdownItemProps } from './PriceBreakdownItem.types'

export const PriceBreakdownItem: FunctionComponent<PriceBreakdownItemProps> = ({
  attributes
}) => {
  return (
    <div data-testid="price-breakdown-item" className="price-breakdown-item">
      <UXComponentRenderer {...attributes.item} />
      <UXComponentRenderer {...attributes.price} />
    </div>
  )
}
